import { cn } from "@/lib/utils";
import { ReactNode } from "react";

interface StickyFilterContainerProps {
  children: ReactNode;
  className?: string;
  maxWidth?: 'sm' | 'md' | 'lg' | 'xl' | '2xl';
}

export const StickyFilterContainer = ({ 
  children, 
  className,
  maxWidth = 'md'
}: StickyFilterContainerProps) => {
  const maxWidthClasses = {
    sm: 'max-w-sm',
    md: 'max-w-md',
    lg: 'max-w-lg',
    xl: 'max-w-xl',
    '2xl': 'max-w-2xl'
  };

  return (
    <div className="sticky z-50 w-full bg-white dark:bg-gray-800" style={{ top: "var(--ys-app-header-h, 0px)" }}>
      <div
        className={cn(
          "mx-auto px-4 py-4 space-y-3",
          "max-w-2xl w-full",
          "bg-white dark:bg-gray-800",
          "backdrop-blur-sm",
          "border-b border-gray-200 dark:border-gray-700",
          "shadow-md",
          "rounded-b-lg",
          className
        )}
      >
        {children}
      </div>
    </div>
  );
};